import { createSelector } from '@reduxjs/toolkit';
import { DEFAULT_UNIT_SENSOR } from '../../controlUnit/api/util/constants';
import { getFeatureToggle } from '../../featureToggle/selectors';
import { useAppSelector } from '../../store.model';
import { SettingsAPI } from '../api/SettingsAPI';

export const getPreferredTemperatureUnitSelector = createSelector(
  [SettingsAPI.endpoints.getAllSettings.select(), getFeatureToggle],
  (response, featureToggleState) => {
    const temperatureUnitUserPreference =
      response.data?.temperatureUnitPreferred;
    const temperatureToggles = featureToggleState?.defaultTemperatureUnit;

    return (
      temperatureUnitUserPreference || temperatureToggles || DEFAULT_UNIT_SENSOR
    );
  }
);

function usePreferredTemperatureUnit() {
  const { data, ...response } = SettingsAPI.useGetAllSettingsQuery();
  const temperatureUnitUserPreference = data?.temperatureUnitPreferred;
  const featureToggleState = useAppSelector(getFeatureToggle);
  const temperatureToggles = featureToggleState?.defaultTemperatureUnit;

  return {
    data:
      temperatureUnitUserPreference ||
      temperatureToggles ||
      DEFAULT_UNIT_SENSOR,
    ...response,
  };
}

export default usePreferredTemperatureUnit;
